import React from 'react'
import { IconButton, Tooltip } from '@material-ui/core'
import { Close } from '@material-ui/icons'

const CloseButton = ({ title, handleClose, classname, size }) => {
  return (
    <>
      <span className={classname ?? ''}>
        <Tooltip title={title}>
          <IconButton
            aria-label={title}
            size={size ?? 'small'}
            onClick={handleClose}
          >
            <Close />
          </IconButton>
        </Tooltip>
      </span>
    </>
  )
}

export default CloseButton
